import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { getPublicReportSettings } from '../api/reportSettings';
import { normalizeReportSettings } from '../config/reportDefinitions';

const ReportSettingsContext = createContext(null);

export function ReportSettingsProvider({ children }) {
  const [settings, setSettings] = useState(() => normalizeReportSettings({}));
  const [ready, setReady] = useState(false);
  const [loadError, setLoadError] = useState(false);

  const load = useCallback(async () => {
    try {
      const data = await getPublicReportSettings();
      setSettings(normalizeReportSettings(data));
      setLoadError(false);
    } catch {
      setSettings(normalizeReportSettings({}));
      setLoadError(true);
    } finally {
      setReady(true);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <ReportSettingsContext.Provider value={{ settings, ready, loadError, refresh: load }}>
      {children}
    </ReportSettingsContext.Provider>
  );
}

export function useReportSettings() {
  return useContext(ReportSettingsContext);
}
